import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import { portfolio } from '../data/siteData';

// IMAGES

import restaurantImg from './assets/restaurant-management.png';
import posImg from './assets/restaurant-pos.png.png';
import hotelImg from './assets/hotel-management.png';
import clothingImg from './assets/clothing-store.png';
import bookstoreImg from './assets/bookstore-management.png';
import tastebiteImg from './assets/tastebite-dashboard.png';

const portfolioImages = [
  restaurantImg,
  posImg,
  hotelImg,
  clothingImg,
  bookstoreImg,
  tastebiteImg
];

function Portfolio() {

  const sliderRef = useRef(null);

  const [isDown, setIsDown] = useState(false);

  const [startX, setStartX] = useState(0);

  const [scrollLeft, setScrollLeft] = useState(0);

  /* =========================
     AUTO SCROLL
  ========================= */

  useEffect(() => {

    const slider = sliderRef.current;

    const autoScroll = setInterval(() => {

      if (!isDown && slider) {

        slider.scrollLeft += 1;

        // INFINITE LOOP

        if (
          slider.scrollLeft >=
          slider.scrollWidth / 2
        ) {
          slider.scrollLeft = 0;
        }
      }

    }, 20);

    return () => clearInterval(autoScroll);

  }, [isDown]);

  /* =========================
     MOUSE EVENTS
  ========================= */

  const handleMouseDown = (e) => {

    setIsDown(true);

    setStartX(
      e.pageX - sliderRef.current.offsetLeft
    );

    setScrollLeft(
      sliderRef.current.scrollLeft
    );
  };

  const handleMouseLeave = () => {
    setIsDown(false);
  };

  const handleMouseUp = () => {
    setIsDown(false);
  };

  const handleMouseMove = (e) => {

    if (!isDown) return;

    e.preventDefault();

    const x =
      e.pageX - sliderRef.current.offsetLeft;

    const walk = (x - startX) * 2;

    sliderRef.current.scrollLeft =
      scrollLeft - walk;
  };

  /* =========================
     TOUCH EVENTS
  ========================= */

  const handleTouchStart = (e) => {

    setIsDown(true);

    setStartX(
      e.touches[0].pageX -
      sliderRef.current.offsetLeft
    );

    setScrollLeft(
      sliderRef.current.scrollLeft
    );
  };

  const handleTouchEnd = () => {

    setIsDown(false);
  };

  const handleTouchMove = (e) => {

    if (!isDown) return;

    const x =
      e.touches[0].pageX -
      sliderRef.current.offsetLeft;

    const walk = (x - startX) * 2;

    sliderRef.current.scrollLeft =
      scrollLeft - walk;
  };

  /* =========================
     WHEEL SCROLL
  ========================= */

  const handleWheel = (e) => {

    e.preventDefault();

    sliderRef.current.scrollLeft += e.deltaY;
  };

  return (

    <section
      className="section portfolio-section"
      id="portfolio"
    >

      <div className="container">

        {/* HEADER */}

        <div className="section-header">

          <p className="section-subtitle">
            Portfolio
          </p>

          <h2 className="section-title">
            Solutions We Have Built
          </h2>

          <p className="section-text center-text">
            We work across multiple industries to create
            software that solves operational and
            customer-facing challenges.
          </p>

        </div>

        {/* SLIDER */}

        <div
          className="portfolio-slider"

          ref={sliderRef}

          // MOUSE EVENTS

          onMouseDown={handleMouseDown}

          onMouseLeave={handleMouseLeave}

          onMouseUp={handleMouseUp}

          onMouseMove={handleMouseMove}

          // TOUCH EVENTS

          onTouchStart={handleTouchStart}

          onTouchEnd={handleTouchEnd}

          onTouchMove={handleTouchMove}

          // WHEEL

          onWheel={handleWheel}
        >

          {/* TRACK */}

          <div className="portfolio-track">

            {[...portfolio, ...portfolio].map(
              (item, index) => {

                const Icon = item.icon;

                return (

                  <div
                    className="portfolio-box"
                    key={index}
                  >

                    {/* IMAGE */}

                    <div className="portfolio-image-wrap">

                      <img
                        src={
                          portfolioImages[
                            index %
                            portfolioImages.length
                          ]
                        }
                        alt={item.title}
                        className="portfolio-image"
                      />

                    </div>

                    {/* ICON */}

                    <div className="icon-wrap">
                      <Icon />
                    </div>

                    {/* CONTENT */}

                    <h3>{item.title}</h3>

                    <p>{item.description}</p>

                  </div>
                );
              }
            )}

          </div>

        </div>

      </div>

    </section>
  );
}

export default Portfolio;